import { useEffect, useState } from "react";
import { getManifestBuildFingerprint, getRunningBuildFingerprint } from "../utils/deployUpdate";

export default function useDeployUpdate() {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    let isDisposed = false;
    const runningFingerprint = getRunningBuildFingerprint();
    if (!runningFingerprint) return; // Development has no hashed production bundle.

    const checkForDeployUpdate = async () => {
      try {
        const response = await fetch("/asset-manifest.json", { cache: "no-store" });
        if (!response.ok) return;
        const latestFingerprint = getManifestBuildFingerprint(await response.json());
        if (!isDisposed && latestFingerprint) {
          setUpdateAvailable(latestFingerprint !== runningFingerprint);
        }
      } catch {
        // Deploy checks should never disturb user flow when offline.
      }
    };

    checkForDeployUpdate();
    const intervalId = window.setInterval(checkForDeployUpdate, 5 * 60 * 1000);
    return () => {
      isDisposed = true;
      window.clearInterval(intervalId);
    };
  }, []);

  return updateAvailable;
}
